export default __webpack_public_path__ + "assets/images/started.048414.avif";